<template>
    <div class="select">
        <select v-model="model" :disabled="disabled">
            <option :value="0" v-if="addDisabledOption">⛔ {{ translate("common.disabled") }}</option>
            <option v-else :value="0">---</option>
            <option :value="bracketType.bracketType" v-for="bracketType in availableBracketTypes" :key="bracketType.bracketType">
                {{ translate(bracketType.name) }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
    import { computed, watch } from "vue";
    import { translate } from "../Common/translations";
    import { BracketTypeConstraintWithTranslationKey } from "../Api/brackets";

    const props = defineProps<{
        lowerLimit: number;
        upperLimit: number;
        bracketTypes: BracketTypeConstraintWithTranslationKey[];
        disabled?: boolean;
        addDisabledOption?: boolean;
    }>();

    const availableBracketTypes = computed(() => {
        return props.bracketTypes.filter(
            bracketType => bracketType.lowerLimit <= props.lowerLimit && bracketType.upperLimit >= props.upperLimit,
        );
    });

    watch(availableBracketTypes, () => {
        if (!availableBracketTypes.value.some(x => x.bracketType === model.value)) {
            model.value = 0;
        }
    });

    const model = defineModel<number>({ default: 1 });
</script>

<style scoped></style>
